// New Beginnings — Lion Face brand mark (image asset).
// Uses the official logo hosted on the customer-assets CDN.
export const LogoMark = ({ className = "w-5 h-5" }) => (
  <img
    src="https://customer-assets-0z36b82j.emergentagent.net/job_fresh-start-journey/artifacts/rtfbksvy_Logo%20Colour.jpg.jpeg"
    alt="New Beginnings Recovery — Lion mark"
    className={`${className} object-contain rounded-full`}
    draggable={false}
    loading="eager"
  />
);

export default LogoMark;
